import { Box, Flex, Text } from '@chakra-ui/react';
import { InquiryWithContext } from '@texas/api/endpoints/inquiryApi';
import { useTranslation } from 'react-i18next';

interface Props {
  inquiry: InquiryWithContext;
}

export function InquiryStatus({ inquiry }: Props) {
  const { t } = useTranslation();

  const status = inquiry.archived
    ? {
        color: 'inquiryOverview.mutedText',
        dot: 'gray.400',
        label: t('inquiry.archived'),
      }
    : inquiry.acceptedDate
    ? {
        color: 'status.success',
        dot: 'green.500',
        label: t('general.accepted'),
      }
    : inquiry.sent && inquiry.acceptedPriceCount > 0
    ? {
        color: 'orange.700',
        dot: 'orange.500',
        label: t('inquiry.underReview'),
      }
    : inquiry.sent && inquiry.priceCount > 0
    ? {
        color: 'texas.burntSienna.500',
        dot: 'texas.burntSienna.500',
        label: t('inquiry.pricesReceived'),
      }
    : inquiry.sent
    ? {
        color: 'orange.700',
        dot: 'orange.500',
        label: t('inquiry.awaitingResponse'),
      }
    : {
        color: 'inquiryOverview.mutedText',
        dot: 'gray.400',
        label: t('inquiry.draft'),
      };

  return (
    <Flex align="center" gap={1.5}>
      <Box boxSize="7px" bg={status.dot} borderRadius="full" flexShrink={0} />
      <Text color={status.color} fontSize="12px" fontWeight="semibold">
        {status.label}
      </Text>
    </Flex>
  );
}
